import { CompanyTypeEnum } from "@gtpl/shared-models/masters";

export class PoReportRequest{
    fromDate:Date;
    toDate:Date;
    saleOrderId?:number;
    purchaseOrderId:number;
    poStatus:string;
    vendorId:number;
    poType?:string;
    unitId?:number;
    createdDate?:Date
    itemNameId?:number;
    excessPercent?:number;
    lifeCycleStatus?:string;
    itemSubCategoryId?:number;
    itemCategoryId?:number;
    company? :CompanyTypeEnum
    createdFromDate?:Date;
    createdToDate?:Date;
    
    
}